module.exports = __webpack_public_path__ + "static/media/logo.7b49bbad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 289
// module chunks = 0